import { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/auth';

export const PublicRoute = ({ children }) => {
    const { token } = useContext(AuthContext);


    return (!token)
        ? children
        : <Navigate to="/" />
};
